const sideMenuItemsData = [
  { page: '/', title: 'Home' },
  { page: '/games', title: 'All Games' },
  { page: '/about', title: 'About' },
  { page: '/faq', title: 'FAQ' },
  { page: '/contact', title: 'Contact' },
]

export default sideMenuItemsData
